import Remote from '@/util/Remote';

class Service {
  getMcmShopList(params) {
    return Remote.get('/activityDic/mcmShopList.do', params);
  }
}

export default new Service();
